/**
 * Family Member [id] Layout
 *
 * Nested layout for family member routes (edit, calendars).
 */

import { Stack } from 'expo-router';

export default function FamilyMemberIdLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="edit" />
      <Stack.Screen name="calendars" />
      <Stack.Screen name="notes" />
    </Stack>
  );
}
